import { render } from "./RawAskView.vue?vue&type=template&id=dd9da942&scoped=true"
import script from "./RawAskView.vue?vue&type=script&lang=js"
export * from "./RawAskView.vue?vue&type=script&lang=js"

import "./RawAskView.vue?vue&type=style&index=0&id=dd9da942&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9da942"]])

export default __exports__